import React, { useState, useEffect } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import SimpleTextField from "./SimpleTextField";
import SimpleTextFieldModel from "../formModels/SimpleTextFieldModel"; // Import the model
import { Stack, Typography, Tooltip } from "@mui/material";

const TextFieldList = ({ title, subtitle, values, onChange, required}) => {
  const [models, setModels] = useState([]);

  // Initialize the models from the provided initial values (strings)
  useEffect(() => {
    if (values && values.length > 0) {
      // If there are initial values, initialize models with them
      const initialModels = values.map((value) => new SimpleTextFieldModel(value));
      setModels(initialModels);
    } else {
      // If no initial values, initialize with one empty model
      setModels([new SimpleTextFieldModel("")]);
    }
  }, [values]);

  const handleAdd = () => {
    const newModel = new SimpleTextFieldModel(""); // Create a new empty model
    const updatedModels = [...models, newModel]; // Add a new model for the input value
    setModels(updatedModels); // Update local state
    onChange(updatedModels.map((model) => model.getValue())); // Notify parent of updated values
  };

  const handleRemove = (indexToRemove) => {
    const updatedModels = models.filter((_, index) => index !== indexToRemove);
    setModels(updatedModels); // Update local state
    onChange(updatedModels.map((model) => model.getValue())); // Notify parent of updated values
  };

  const handleModelChange = (index, newValue) => {
    const updatedModels = [...models];
    updatedModels[index].setValue(newValue); // Update the specific model
    setModels(updatedModels);
    onChange(updatedModels.map((model) => model.getValue())); // Notify parent of updated values
  };

  return (
    <div>
      <Typography variant="p" gutterBottom>{title}</Typography>
      {/* Render the list of models */}
      {models.map((model, index) => (
        <Stack key={index} spacing={2} sx={{pt: 1}}>
          <SimpleTextField
            label={`Item ${index + 1}`}
            helperText = {subtitle}
            value={model.getValue()} // Get the value from the model
            onChange={(newValue) => handleModelChange(index, newValue)} // Update the specific model
            required={required}
            // error={error ? !!error : false}
          />
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Tooltip title={<><span>Add another </span><span>{title}</span></>}><AddCircleIcon onClick={handleAdd} /></Tooltip>
            {models.length > 1 && ( // Show the Remove button only if more than one item
              <Tooltip title={<><span>Remove this </span><span>{title}</span></>}><RemoveCircleIcon onClick={() => handleRemove(index)} /></Tooltip>
            )}
          </div>
        </Stack>
      ))}
    </div>
  );
};

export default TextFieldList;
